<div class='wrapper'>
    <div class="panel-title">
        Send referral
    </div>

    <div class="send-referral-area">
      <form [formGroup]="uploadForm">

        <div class="row mb-3">
          <div class="col-md-6 col-12">
            <button (click)="bulkUpdload()" type="button" class="btn btn-block btn-lg btn-greengo" npFocusOutClicked>
              Bulk Upload
            </button>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-md-6">
            <mat-form-field [ngClass]="{'is-invalid': emailCtrl.hasError('required') && emailCtrl.touched,
              'is-valid':emailCtrl.valid && emailCtrl.touched }">
              <input matInput formControlName="email" type="email" npDetectFocus #ipEmail="detectFocus" placeholder="Email">
            </mat-form-field>
            <div *ngIf="emailCtrl.hasError('required') && emailCtrl.touched && !ipEmail.isFocus ">
              <p class="err-message">Please input information here</p>
            </div>
          </div>

          <div class="form-group col-md-6 col-12">
            <mat-form-field [ngClass]="{'is-invalid': firstNameCtrl.hasError('required') && firstNameCtrl.touched,
              'is-valid':firstNameCtrl.valid && firstNameCtrl.touched }">
              <input matInput formControlName="firstName" type="text" npDetectFocus #ipFirstName="detectFocus" placeholder="First Name">
            </mat-form-field>
            <div *ngIf="firstNameCtrl.hasError('required') && firstNameCtrl.touched && !ipFirstName.isFocus ">
              <p class="err-message">Please input information here</p>
            </div>
          </div>

          <div class="form-group col-md-6 col-12">
            <mat-form-field [ngClass]="{'is-invalid': lastNameCtrl.hasError('required') && lastNameCtrl.touched,
              'is-valid':lastNameCtrl.valid && lastNameCtrl.touched }">
              <input matInput formControlName="lastName" type="text" npDetectFocus #ipLastName="detectFocus" placeholder="Last Name">
            </mat-form-field>
            <div *ngIf="lastNameCtrl.hasError('required') && lastNameCtrl.touched && !ipLastName.isFocus ">
              <p class="err-message">Please input information here</p>
            </div>
          </div>

          <div class="form-group col-md-6 col-12">
            <button type="button" class="btn btn-block btn-lg" (click)="sendReferral()" [ngClass]="{
              'btn-greengo': uploadForm.valid,
              'btn-inactive': !uploadForm.valid
            }" npFocusOutClicked>
              Send Referral
            </button>
          </div>

        </div>
      </form>
</div>